import * as RA from 'ramda-adjunct';

import { createUserTV } from "../../../../models/user.model";
import { tv } from "../../../../models/text-value.model";
import { snakeCaseToWords } from "../../../../utility";
import { pathOr } from 'ramda';

const invoice_projects = pathOr([], ['invoiceData', 'invoice_projects']);
const invoice_status = pathOr([], ['invoiceData', 'invoice_status']);

export const invoiceGetters = {
  invoiceData: (state) => state.invoiceData,
  invoiceList: (state) => state.invoiceList || [],
  invoiceListFilter: (state) => state.invoiceListFilter,

  // TODO: Nest all State under this Object
  invoiceDetails: (state) => state.invoiceDetails,

  invoice_projects: (state) => {
    return invoice_projects(state);
  },
  invoice_projectsTV: (state) => {
    // console.log(invoice_projects(state));
    // console.log(invoice_status(state));
    return invoice_projects(state).map(e => ({
      text: e.invoice_project_name,
      value: e.invoice_project_id
    }))
  },
  invoice_status: (state) => {
    return invoice_status(state);
  },
  // WHY THIS EMPTY ???
  invoice_statusTV: (state) => {
    // console.log('invoice_statusTV', {
    //   is: invoice_status(state).map(e => ({
    //     text: e[0],
    //     // text: snakeCaseToWords(e[0]),
    //     value: e[0]
    //   })),
    //   'invoice_status(state)': invoice_status(state)
    // });
    return invoice_status(state).map(e => ({
      text: e[0],
      value: e[0]
    }))
  },
  inv_statTV: (state) => {
    return invoice_status(state).map(e => ({
      text: e[0],
      value: e[1]
    }))
  },
  usersTV: (state) => createUserTV(pathOr([], ['invoiceData', 'users'], state)),
  currencies: (state) => pathOr([], ['invoiceData', 'currencies'], state),
  currencyTV: (state) => pathOr([], ['invoiceData', 'currencies'], state)
    .map(tv('currency_iso', 'currency_id')),
  invoice_list_start_from: (state) => state.invoice_list_start_from,
  invoice_list_scrolltop: (state) => state.invoice_list_scrolltop,

};
